import { useIsFreePortal } from '../../hooks/inventory/useProductInventory';
import { useIsSeatsUser } from '../../hooks/user/useUserInfo';
const UPSELL_STARTER_API_NAME = 'crm-suite-starter-bundle';

// Note, this does not take into account the Public Pricing Page logic
export const useShowUpsellCustomerPlatformMerchCard = () => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isSeatsUser = useIsSeatsUser();
  return {
    showUpsell: isFreePortal && isSeatsUser && !isInventoryLoading,
    loading: isInventoryLoading,
    upsellApiName: UPSELL_STARTER_API_NAME
  };
};